import React from 'react';
import { Button } from '@material-ui/core';
import useStyles from './styles'
import clsx from 'clsx'

const Buttons = ({
    text,
    disabled,
    customClass,
    onClick
}) => {
    const classes = useStyles()
    return (
        <Button
            disabled={disabled}
            classes={{ root: classes.root }}
            className={clsx(
                classes.buttonDefault,
                classes[`${customClass}`],
                disabled && classes.isDisabled,
            )}
            onClick={onClick}
        >
            {text}
        </Button>
    )
}

export default Buttons